var submitButton = document.querySelector('.product-form__submit');
var productFormInputs = document.querySelectorAll('.product-form__input');
var unselectedVariantOptionsAlert = document.querySelector('.unselectedVariantOptions');
var unselectedVariantOptionsArr = [];

submitButton.addEventListener('click', (event) => {
  for (let i = 0; i < productFormInputs.length; i++) {
    if (productFormInputs[i].querySelector('fieldset input:checked') == null ) {
      unselectedVariantOptionsAlert.classList.remove('hidden');
      unselectedVariantOptionsArr.push(productFormInputs[i].querySelector('input').getAttribute('name'));
      event.preventDefault();
    }
    if(document.querySelectorAll('fieldset input:checked').length === productFormInputs.length) {
      unselectedVariantOptionsAlert.classList.add('hidden');
    }
  }

  document.querySelector('.unselectedVariantOptions span').textContent = unselectedVariantOptionsArr.join(' and ');
  unselectedVariantOptionsArr = [];
});